import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="June 6, 2026"
      path="/terms-of-service"
      description="The terms and conditions governing your use of Travel Club Navigator Group's website and services."
    >
      <p data-testid="terms-intro">
        These Terms of Service ("Terms") govern your access to and use of{" "}
        <a href="https://travelclubnavigator.co" className="text-primary hover:underline">
          travelclubnavigator.co
        </a>{" "}
        and all related content and services provided by Travel Club Navigator Group ("we," "us," or
        "our"). By using the Site, you agree to these Terms. If you do not agree, please do not use the Site.
      </p>

      <LegalSection heading="1. Use of the Site">
        <p>
          You may use the Site only for lawful purposes and in accordance with these Terms. You agree not
          to misuse the Site, interfere with its operation, or attempt to access it in an unauthorized manner.
        </p>
      </LegalSection>

      <LegalSection heading="2. Informational Content &amp; Reviews">
        <p>
          Our reviews, guides, and blog articles are provided for general informational purposes only and
          reflect our opinions and research. They do not constitute financial, legal, or professional advice.
          Travel club, timeshare, and third-party brand names are the property of their respective owners and
          are referenced for identification and commentary purposes.
        </p>
      </LegalSection>

      <LegalSection heading="3. Bookings &amp; Payments">
        <ul className="list-disc space-y-2 pl-6">
          <li>Prices are displayed per room, per night unless otherwise stated, and are subject to change until a booking is confirmed.</li>
          <li>Payments are processed securely through Stripe. By submitting a payment you authorize the charge shown at checkout (full amount or deposit, as selected).</li>
          <li>A deposit reserves your booking; the remaining balance is due as communicated by our team.</li>
          <li>All bookings are subject to availability and final confirmation by us and/or the applicable travel provider.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="4. Cancellations &amp; Refunds">
        <p>
          Cancellation and refund terms vary by package and travel provider and will be communicated at or
          before the time of booking. Deposits may be non-refundable. Please contact{" "}
          <a href="mailto:hello@travelclubnavigator.co" className="text-primary hover:underline">
            hello@travelclubnavigator.co
          </a>{" "}
          with any cancellation request.
        </p>
      </LegalSection>

      <LegalSection heading="5. Intellectual Property">
        <p>
          All content on the Site — including text, graphics, logos, and images — is owned by or licensed to
          Travel Club Navigator Group and is protected by applicable intellectual property laws. You may not
          reproduce, distribute, or create derivative works without our prior written permission.
        </p>
      </LegalSection>

      <LegalSection heading="6. Third-Party Links &amp; Services">
        <p>
          The Site may link to or rely on third-party websites and services (such as travel providers and
          payment processors). We are not responsible for the content, policies, or practices of third parties.
        </p>
      </LegalSection>

      <LegalSection heading="7. Disclaimers">
        <p>
          The Site and its content are provided "as is" and "as available" without warranties of any kind,
          express or implied. We do not warrant that the Site will be uninterrupted, error-free, or free of
          harmful components.
        </p>
      </LegalSection>

      <LegalSection heading="8. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Travel Club Navigator Group shall not be liable for any
          indirect, incidental, special, or consequential damages arising from your use of the Site or any
          booking made through it.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Changes are effective when posted, as indicated by the
          "Last updated" date above. Your continued use of the Site constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact Us">
        <p>
          Questions about these Terms? Email{" "}
          <a href="mailto:hello@travelclubnavigator.co" className="text-primary hover:underline">
            hello@travelclubnavigator.co
          </a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
